import { CSSProperties } from "react";

type RingLoaderProps = {
  size?: "small" | "large";
  style?: CSSProperties;
  className?: string;
};

const px = (s: "small" | "large") => (s === "small" ? 12 : 16);

/** This icon component was generated by ChatGPT */
const RingLoader = ({ size = "small", style, className }: RingLoaderProps) => {
  const dim = px(size);
  return (
    <svg
      width={dim}
      height={dim}
      viewBox="0 0 50 50"
      style={style}
      className={className}
      aria-hidden
    >
      {/* Uses currentColor so it matches the Tag's text color */}
      <circle
        cx="25"
        cy="25"
        r="20"
        fill="none"
        stroke="currentColor"
        strokeWidth="6"
        strokeLinecap="round"
        strokeDasharray="90 140"
      >
        {/* SMIL is supported in modern browsers; simple, no CSS needed */}
        <animateTransform
          attributeName="transform"
          type="rotate"
          from="0 25 25"
          to="360 25 25"
          dur="0.8s"
          repeatCount="indefinite"
        />
      </circle>
    </svg>
  );
};
export default RingLoader
